import React from "react";
import InputBar from "components/InputBar/InputBar";
import PropTypes from "prop-types";
import "components/SearchBar/SearchBar.css";
import { SearchIcon } from "constants/icons";

//Enables functionality of filtering a list by user's input.
function SearchBar({
  data,
  filterKey,
  onChange,
  className: customClassName = "",
}) {
  const componentTexts = window.appTexts.home_page.common_text;
  const filterDataByUserInput = function (name, value) {
    //Reset data to its initial state.
    if (!value) {
      return onChange(data);
    }

    //Calculates filtered data.
    let filteredData = data.filter(function (element) {
      //Prevents lowercase transformation
      let temp = element;

      //If element matches the filter text, return it.
      if (element[filterKey].toLowerCase().includes(value.toLowerCase())) {
        return temp;
      }
      return undefined;
    });

    return onChange(filteredData);
  };

  return (
    <div className={"search-bar__wrapper " + customClassName}>
      <InputBar
        type="search"
        className="search-bar"
        onChange={filterDataByUserInput}
        inputProps={{ placeholder: componentTexts.searchbar_placeholder }}
        PlaceholderIcon={SearchIcon}
      />
    </div>
  );
}

SearchBar.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  filterKey: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default SearchBar;
